import FileOutlineIcon from '@eduzz/houston-icons/FileOutline';
import ParametersIcon from '@eduzz/houston-icons/Parameters';
import List from '@eduzz/houston-ui/List';
import { DialogTitle, FormHelperText } from '@material-ui/core';
import { Dialog, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { PostAddOutlined } from '@material-ui/icons';
import React from 'react';
import AddPin from 'v2/components/Shared/AddPin';
import { run } from 'validations/ruleRunner';

import AlpaClass from './Form/Alpaclass';
import File from './Form/File';
import Nutror from './Form/Nutror';
import Other from './Form/Other';
import DeliveryList from './List';
import styles from './styles';
import Validations from './validations';
import { FormContent } from '../../EditProduct/components/FormContent';

interface IProps {
  deliveries: any;
  onChange?: any;
  fade?: any;
  loading?: boolean;
  onChangeRequiredFields?: any;
  isInfo?: boolean;
  offer?: any;
  classes?: any;
  ref?: any;
  newProduct?: boolean;
  isService?: boolean;
}

interface IStates {
  deliveries: any;
  modal: boolean;
  modalFile: boolean;
  modalNutror: boolean;
  modalOther: boolean;
  modalAlpaClass: boolean;
  modalPins: boolean;
  showErrors: boolean;
  validationErrors: any;
}

class Delivery extends React.Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      deliveries: this.props.deliveries,
      modalFile: false,
      modalNutror: false,
      modalOther: false,
      modalAlpaClass: false,
      modalPins: false,
      modal: false,
      showErrors: false,
      validationErrors: run({ deliveries: props.offer && props.offer.deliveries }, Validations),
    };
  }
  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  changeState = () => {
    let { deliveries, onChangeRequiredFields } = this.props;
    let newState = { ...this.state };
    newState.deliveries = deliveries;
    newState.validationErrors = run({ deliveries }, Validations);
    this.setState(newState);
    if (onChangeRequiredFields) {
      onChangeRequiredFields('deliveryRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
    }
  };
  componentDidUpdate(prevProps: IProps) {
    if (this.props.deliveries !== prevProps.deliveries) {
      this.changeState();
    }
  }
  componentDidMount() {
    if (!this.props.loading) {
      this.changeState();
    }
  }
  modal = () => {
    this.setState({ modal: !this.state.modal });
  };
  modalFile = () => {
    this.setState({ modalFile: !this.state.modalFile });
  };
  modalNutror = () => {
    this.setState({ modalNutror: !this.state.modalNutror });
  };
  modalOther = () => {
    this.setState({ modalOther: !this.state.modalOther });
  };
  modalAlpaClass = () => {
    this.setState({ modalAlpaClass: !this.state.modalAlpaClass });
  };

  selectDelivery = (delivery: any) => {
    switch (delivery) {
      case 'FILES':
        this.setState({ modal: false, modalFile: true });
        break;
      case 'NUTROR':
        this.setState({ modal: false, modalNutror: true });
        break;
      case 'OTHERS':
        this.setState({ modal: false, modalOther: true });
        break;
      case 'ALPACLASS':
        this.setState({ modal: false, modalAlpaClass: true });
        break;
      case 'PIN':
        this.setState({ modal: false, modalPins: true });
        break;
      default:
    }
  };
  onEditDeliveries = (deliveries: any) => {
    this.setState({ deliveries });
    this.onChangeDeliveries(deliveries);
  };

  onAddNewItem = (item: any) => {
    let newDeliveries = this.state.deliveries;
    newDeliveries = newDeliveries && Array.isArray(newDeliveries) ? newDeliveries : [];
    newDeliveries.push(item);
    this.setState({ deliveries: newDeliveries, modalFile: false, modalOther: false, modalNutror: false });
    this.onChangeDeliveries(newDeliveries);
  };

  ifHasNutror = (items: any[]) => {
    return (items || []).some((i) => i.method_id == 24);
  };

  ifHasAlpaClass = (items: any[]) => {
    return (items || []).some((i) => i.method_id == 47);
  };

  ifHasHotmartFormat = (items: any[]) => {
    return (items || []).some((i) => i.method_id == 4);
  };

  onChangeDeliveries = (deliveries: any) => {
    const { onChange } = this.props;

    if (onChange) {
      let files: any = {};
      let nutror: any = {};
      let others: any = [];
      let newDeliveries: any = [];

      let newFiles = deliveries && deliveries.length ? deliveries.filter((item: any) => item.method_id === '5') : false;
      let filesId: any = [];
      for (let i = 0; i < newFiles.length; i++) {
        let nf = newFiles[i];
        if (nf.files && nf.files.length) {
          filesId = filesId.concat(
            nf.files.map((fil: any) => {
              return fil && fil.upload_id ? fil.upload_id : fil;
            })
          );
        } else {
          filesId = filesId && filesId.length ? filesId : false;
        }
      }
      if (Array.isArray(filesId) && filesId.length) {
        files.method_id = '5';
        files.files = filesId;
      } else {
        files = false;
      }
      nutror = this.ifHasNutror(deliveries) ? deliveries.filter((item: any) => item.method_id === '24')[0] : false;
      others = deliveries && deliveries.length ? deliveries.filter((item: any) => item.method_id !== '5' && item.method_id !== '24') : false;
      files && newDeliveries.push(files);
      nutror && newDeliveries.push(nutror);
      others && (newDeliveries = newDeliveries.concat(others));
      onChange(newDeliveries);
    }
  };

  onAddPins = (pinConfig: any) => {
    this.setState({ modalPins: false });
    this.onAddNewItem({
      method_id: 9,
      method_name: `Lote ${pinConfig.id} - Quantidade de pins: ${pinConfig.pins.length}`,
      type: 'pins',
      can_modify: true,
      id: pinConfig.id,
      batch: [pinConfig.id],
      instructions: pinConfig.instruction,
      limit_per_sale: pinConfig.buy_limit ? pinConfig.qt_limit : 0,
      notify_low_stock: pinConfig.qt_warning ? pinConfig.qt_notify : 0,
    });
  };

  onCancelAddPins = () => {
    this.setState({ modalPins: false });
  };

  render() {
    const { deliveries } = this.state;
    const { loading, isService, isInfo } = this.props;
    const title = isService ? 'Entregas de arquivo (opcional)' : 'Entregas de produto';
    return (
      <FormContent
        title={title}
        loading={loading}
        action={
          <Button
            id='product-add-delivery'
            onClick={this.modal}
            color='primary'
            variant='outlined'
            fullWidth
            style={{ float: 'right' }}
            startIcon={<PostAddOutlined />}
          >
            Adicionar Entrega
          </Button>
        }
      >
        <Grid container spacing={2} alignItems='center'>
          {isInfo && this.isValid('deliveries') && this.errorFor('deliveries') && (
            <Grid item xs={12}>
              <FormHelperText error>Obrigatório pelo menos uma entrega cadastrada.</FormHelperText>
            </Grid>
          )}

          {isService && (
            <Grid item xs={12}>
              <FormHelperText>Para vendas do tipo Serviço, você pode adicionar uma entrega se desejar, mas não é obrigatório.</FormHelperText>
            </Grid>
          )}
          <Grid container>
            <Grid item xs={12} md={12}>
              <DeliveryList deliveries={deliveries} onEditSomething={this.onEditDeliveries} offer={this.props.offer} />
            </Grid>
          </Grid>

          <Dialog onClose={this.modal} open={this.state.modal}>
            <DialogTitle>Tipo de entrega</DialogTitle>
            <List dividers>
              <List.Item onClick={() => this.selectDelivery('FILES')} id='product-delivery-files'>
                <List.Left>
                  <FileOutlineIcon size={40} />
                </List.Left>
                <List.Text title='Arquivos' description={"PDF's, documentos, imagens e e-books."} />
              </List.Item>
              {!isService && (
                <>
                  {!this.ifHasNutror(deliveries) && (
                    <List.Item onClick={() => this.selectDelivery('NUTROR')} id='product-delivery-nutror'>
                      <List.Left>
                        <img src='/img/nutror-symbol.svg' width='40' />
                      </List.Left>
                      <List.Text title='Nutror' description={'Nossa plataforma de membros.'} />
                    </List.Item>
                  )}
                  {!this.ifHasAlpaClass(deliveries) && (
                    <List.Item onClick={() => this.selectDelivery('ALPACLASS')} id='product-delivery-alpaclass'>
                      <List.Left>
                        <img src='/img/alpaclass.svg' width='40' />
                      </List.Left>
                      <List.Text
                        title={
                          <>
                            <span style={{ marginRight: 10 }}>Alpaclass</span>
                            <span style={{ color: '#8ade8a', fontWeight: 500 }}>Novo</span>
                          </>
                        }
                        description={'Plataforma de área de membros.'}
                      />
                    </List.Item>
                  )}

                  {/* {!newProduct && (
                <List.Item  onClick={() => this.selectDelivery('PIN')}>
                  <Avatar>
                    <Icon>fiber_pin</Icon>
                  </Avatar>
                  <List.Text  title='Pins' description={'Cadastro de pins'} />
                </List.Item>
              )} */}
                  <List.Item onClick={() => this.selectDelivery('OTHERS')} id='product-delivery-others'>
                    <List.Left>
                      <ParametersIcon size={40} />
                    </List.Left>
                    <List.Text title='Outros' description={'LeadLovers, customizado e outros.'} />
                  </List.Item>
                </>
              )}
            </List>
            <Button onClick={this.modal} variant='text' color='primary'>
              Fechar
            </Button>
          </Dialog>

          <File isModal={true} open={this.state.modalFile} onClose={this.modalFile} onOk={this.onAddNewItem} />
          <Nutror isModal={true} open={this.state.modalNutror} onClose={this.modalNutror} onOk={this.onAddNewItem} />

          <Other
            isModal={true}
            deliveries={this.props.deliveries}
            open={this.state.modalOther}
            newProduct={this.props.newProduct}
            onClose={this.modalOther}
            onOk={this.onAddNewItem}
            offer={this.props.offer}
            hasHotmart={this.ifHasHotmartFormat(deliveries)}
          />
          <AlpaClass
            isModal={true}
            open={this.state.modalAlpaClass}
            newProduct={this.props.newProduct}
            onClose={this.modalAlpaClass}
            onOk={this.onAddNewItem}
            offer={this.props.offer}
          />
          <AddPin productId={this.props.offer.id} open={this.state.modalPins} onConfirm={this.onAddPins} onCancel={this.onCancelAddPins} />
        </Grid>
      </FormContent>
    );
  }
}

export default styles(Delivery);
